import { css } from '@emotion/react';
import { BiPhone } from 'react-icons/bi';
import { Link } from 'react-router-dom';

import Logo from '~/common/components/Logo.tsx';

function Footer() {
  return (
    <footer css={styles.footerWrapper}>
      <div css={styles.inner}>
        {/* 좌측 회사 정보 */}
        <div css={styles.left}>
          <div css={styles.logoWrapper}>
            <Link to="/">
              <Logo height="40px" />
            </Link>
          </div>

          <div css={styles.companyInfo}>
            <div css={styles.legalLinks}>
              <Link to="/terms">이용약관</Link>
              <span css={styles.dot}>•</span>
              <Link to="/privacy">개인정보처리방침</Link>
            </div>
          </div>
        </div>

        {/* 우측 강조된 상담 바 */}
        <div css={styles.right}>
          <div css={styles.supportBar}>
            <div css={styles.phoneRow}>
              <div css={styles.phoneIcon}>
                <BiPhone />
              </div>

              <p css={styles.phoneNumber}>010-5844-8125</p>
            </div>

            <p css={styles.desc}>
              365일 24시간 전화 · 문자 상담 가능
              <br />
              언제든 Hoya를 찾아주세요
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

const styles = {
  footerWrapper: css`
    width: 100%;
    padding: var(--space-10) 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    color: var(--color-text-inverse);
  `,

  inner: css`
    width: 100%;
    max-width: var(--container-max);
    margin: 0 auto;
    padding: 0 var(--space-6);

    display: flex;
    justify-content: space-between;
    gap: var(--space-10);

    @media (max-width: 768px) {
      flex-direction: column;
      gap: var(--space-6);
    }
  `,

  left: css`
    flex: 1;
  `,

  logoWrapper: css`
    margin-bottom: var(--space-4);

    && img {
      height: 100px;
      margin-left: -11px;
    }
  `,

  companyInfo: css`
    font-size: var(--font-sm);
    line-height: var(--line-normal);
    opacity: 0.8;

    p {
      margin-bottom: var(--space-1);
    }
  `,

  legalLinks: css`
    margin-top: var(--space-3);
    display: flex;
    align-items: center;
    gap: var(--space-2);

    a {
      color: var(--color-text-inverse);
      font-size: var(--font-sm);
      opacity: 0.85;
      transition: var(--transition-fast);
    }

    a:hover {
      opacity: 1;
    }
  `,

  dot: css`
    opacity: 0.5;
  `,

  right: css`
    flex: 0.8;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media (max-width: 768px) {
      justify-content: flex-start;
    }
  `,

  /** ⭐ 강조된 상담 바 스타일 */
  supportBar: css`
    padding: var(--space-5);
    border-left: 3px solid var(--color-primary);
    background: rgba(255, 255, 255, 0.04);
    border-radius: var(--radius-md);

    display: flex;
    flex-direction: column;
    gap: var(--space-3);

    box-shadow: var(--shadow-sm);
  `,

  phoneRow: css`
    display: flex;
    align-items: center;
    gap: var(--space-3);
  `,

  phoneIcon: css`
    color: var(--color-primary);

    svg {
      width: 26px;
      height: 26px;
    }
  `,

  phoneNumber: css`
    font-size: var(--font-xl);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-tight);
    color: var(--color-primary);
  `,

  desc: css`
    font-size: var(--font-sm);
    line-height: var(--line-normal);
    opacity: 0.75;
  `,
};
